module.exports = __webpack_public_path__ + "static/media/click2.fe0ded65.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/click2.wav
// module id = 233
// module chunks = 0